import PropTypes from 'prop-types';

import {
  BannerContainer,
  BannerTitle,
  BannerDescription,
  StyledButton
} from './PromotionalBanner.style';

function PromotionalBanner({
  title, description, ctaText, onCtaClick
}) {
  return (
    <BannerContainer>
      <BannerTitle>
        {title}
      </BannerTitle>
      <BannerDescription>
        {description}
      </BannerDescription>
      <StyledButton onClick={onCtaClick}>
        {ctaText}
      </StyledButton>
    </BannerContainer>
  );
}

PromotionalBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  onCtaClick: PropTypes.func.isRequired
};

export default PromotionalBanner;
